/**
 *  © 2025 -2026 DXC Technology, all rights reserved.
 *  Material published by DXC Technology on these web pages/mobile
 *  app may not be reproduced without permission.
 */

import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
const DropdownFilterList = ({ listData, clickSortChange, contentType, activeFilterContent }) => {
  const [dropdownHidden, setDropdownHidden] = useState(false);
  //const [filterList, setFilterList] = useState([]);
  const [activeFilter, setActiveFilter] = useState(Object.keys(listData[0])[0]);
  const [optionList, setOptionList] = useState(listData);
  const Keyboard = { UP: 38, DOWN: 40, LEFT: 37, ENTER: 13, RIGHT: 39, ESCAPE: 27, TAB: 9 };
  useEffect(() => {
    window.addEventListener('click', hideDropdown);
    return () => {
      window.removeEventListener('click', hideDropdown);
    };
  }, [dropdownHidden]);

  useEffect(() => {
    if (activeFilter)
      setOptionList(
        listData && listData.filter((element) => !element.hasOwnProperty(activeFilter))
      );
  }, [activeFilter]);

  const hideDropdown = () => {
    if (dropdownHidden) {
      setDropdownHidden(false);
    }
  };

  const openDropDown = (e) => {
    e.stopPropagation();
    const code = e && (e.keyCode || e.which);
    const listItems = e.target && e.target.querySelectorAll('#exp_elem_list li');
    if (code === Keyboard.ENTER || e.type === 'click') {
      setDropdownHidden(!dropdownHidden);
    } else if (code === Keyboard.ESCAPE || code === Keyboard.TAB) {
      setDropdownHidden(false);
    } else if (code === Keyboard.DOWN) {
      listItems && listItems[0] && listItems[0].focus();
      e.preventDefault();
    }
  };

  const showFilterClick = (data) => {
    setActiveFilter(data);
    clickSortChange(data, contentType, activeFilterContent);
  };

  const focusActiveEelement = (e) => {
    const filterDropdwonBar = e.target.parentElement.parentElement.parentElement;
    const options = filterDropdwonBar && filterDropdwonBar.querySelector('non-keyboard-outline');
    options &&
      options.classList &&
      options.classList.contains('non-keyboard-outline') &&
      options.classList.remove('non-keyboard-outline');
    setTimeout(() => {
      filterDropdwonBar && filterDropdwonBar.classList.add('non-keyboard-outline');
      filterDropdwonBar.focus();
    }, 100);
  };

  const focusListItem = (e, index, data) => {
    e.stopPropagation();
    const code = e && (e.keyCode || e.which);
    const listItems = document.querySelectorAll('#exp_elem_list li');
    if (code === Keyboard.DOWN) {
      e.preventDefault();
      listItems && listItems[index + 1] && listItems[index + 1].focus();
    } else if (code === Keyboard.UP) {
      e.preventDefault();
      listItems && listItems[index - 1] && listItems[index - 1].focus();
    } else if (code === Keyboard.ESCAPE || code === Keyboard.TAB) {
      dropdownHidden && setDropdownHidden(!dropdownHidden);
      focusActiveEelement(e);
    } else if (code === Keyboard.ENTER) {
      setDropdownHidden(!dropdownHidden);
      focusActiveEelement(e);
      showFilterClick(data);
    }
  };

  const borderClip = () => {
    return optionList?.length === 1 ? 'only-button' : dropdownHidden ? '' : 'not-hover';
  };

  const getBtnCTA = () => {
    return listData.find((item) => item.hasOwnProperty(activeFilter))?.[activeFilter];
  };

  return (
    <React.Fragment>
      <div className="filter_content mutv-shows__filter__wrapper">
        <div
          className={`season-filter_dropdown ${borderClip()}`}
          tabIndex="0"
          onClick={() => optionList.length > 1 && setDropdownHidden(!dropdownHidden)}
          onKeyDown={(e) => optionList.length > 1 && openDropDown(e)}
          aria-label={`Select`}
          aria-haspopup="listbox"
          role="listbox"
          aria-expanded={dropdownHidden}
          id="exp_elem"
        >
          <button
            aria-labelledby="exp_elem exp_button"
            aria-haspopup="listbox"
            id="exp_button"
            tabIndex="-1"
            aria-hidden="true"
            className={`${borderClip()}`}
          >
            {getBtnCTA()}
            {optionList.length > 1 && <i className="icon-chevron-down"></i>}
          </button>
          <div id="exp_elem_list" aria-haspopup="listbox" aria-labelledby="exp_elem">
            <ul
              tabIndex={dropdownHidden ? 0 : -1}
              role="listbox"
              aria-labelledby="exp_elem"
              className={
                dropdownHidden ? 'filter-dropdown-wrapper' : 'hidden filter-dropdown-wrapper'
              }
            >
              {optionList.map((item, index) => {
                const [keys, value] = Object.entries(item)[0];
                return (
                  <li
                    key={keys}
                    data-test={index}
                    id={`exp_elem_${index}`}
                    tabIndex={!dropdownHidden ? 0 : -1}
                    onClick={(e) => {
                      showFilterClick(keys, 'contentList');
                    }}
                    onKeyDown={(e) => {
                      focusListItem(e, index, value);
                    }}
                  >
                    {value}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default withTranslation()(DropdownFilterList);
